import { Alert } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkButtonDetails from 'src/components/LinkButtonDetails/LinkButtonDetails';

type Props = {
  items: { rowNumber: number; email: string }[];
};

const DuplicateEmailsNotification: React.FC<Props> = ({ items }) => {
  const { t: tCommon } = useTranslation();
  const { t: tResourceBase } = useTranslation('resourceBase');

  if (items.length === 0) {
    return null;
  }

  return (
    <Alert data-color="danger" className="margin-bottom--2">
      <p>{tResourceBase('import.duplicateEmailsFound')}</p>

      <LinkButtonDetails text={tResourceBase('showDuplicateEmails')}>
        <ul>
          {items.map(({ email, rowNumber }, index) => (
            <li key={index}>
              {email} ({tCommon('row')}: {rowNumber})
            </li>
          ))}
        </ul>
      </LinkButtonDetails>
    </Alert>
  );
};

export default DuplicateEmailsNotification;
